import { createAction, createSlice, PrepareAction } from "@reduxjs/toolkit";
import { IUser } from "interfaces/IUser";
import { persistUser, readUser } from "services/localStorage.service";

export interface UserState {
  user: IUser | null;
  isAnyProject: boolean;
  isLoading: boolean;
  userInformation: any;
}

const initialState: UserState = {
  user: readUser(),
  isAnyProject: true,
  userInformation: {
    subscription: {
      is_active: false,
    },
    payment: {
      is_active: false,
    },
    appSettings: {
      is_active: false,
    },
    features: {
      is_active: false,
    },
    feature_list: [],
    generalInfo: {
      is_project_available: false,
      default_project_details: {
        id: 0,
        name: "",
      },
      is_search_available: true,
      is_talent_pool_available: false,
      is_team_available: false,
    },
    credits: {
      candidate_screening: false,
      email_integration: false,
      export_candidates: false,
      total_candidate_screening_credits: 0,
      total_candidate_screening_credits_remaining: 0,
      total_candidate_screening_credits_used: 0,
    },
    is_hr_flow: false,
    products: {
      product_id: 0,
      product_name: "",
    },
    user_role: null,
    version: null,
  },
  isLoading: false,
};

export const setUser = createAction<PrepareAction<IUser>>("user/setUser", (newUser) => {
  persistUser(newUser);
  return {
    payload: newUser,
  };
});

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    //setuserData
    setUserData: (state, action) => {
      // const { project_details, is_project_available, isAnyProject } = action.payload;
      // state.userInformation.generalInfo.default_project_details = project_details;
      // state.userInformation.generalInfo.is_project_available = is_project_available;
      // state.isAnyProject = isAnyProject;
      console.log("action.payload1111", action.payload);
      state.userInformation = action.payload;
    },
    setUserLoading: (state, action) => {
      state.isLoading = action.payload; // Set loading state
    },
  },
  extraReducers: (builder) => {
    builder.addCase(setUser, (state, action) => {
      state.user = action.payload;
    });
  },
});

export const { setUserData, setUserLoading } = userSlice.actions;

export default userSlice.reducer;
